import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FlaggedFund.css'
// import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
import ReactTooltip from 'react-tooltip'
// import moment from 'moment'

@CSSModules(Styles)
export default class FlaggedFund extends Component {
  static propTypes = {
    totalFunds: PropTypes.number,
    assets: PropTypes.number
  }
  constructor(props){
    super(props)
  }

  render() {
    function renderStatCount(tip, count, label){
      return (
        <div
          styleName='stat'
          data-multiline
          data-effect='solid'
          data-tip={tip}
          data-html
          data-place='bottom'
          data-for='flaggedfund-tooltip'
        >
          <div styleName='stat-count-wrapper'>
            <div styleName='stat-count'>{count}</div>
          </div>
          <div styleName='stat-label'>{label}</div>
        </div>
      )
    }

    return (
      <div>
        {
          renderStatCount(
            format.tooltipHtml(
              'Number of funds analyzed and scored from this family.'
            ),
            format.number(this.props.totalFunds),
            'funds scored'
          )
        }
        {
          renderStatCount(
            format.tooltipHtml(
              'Assets under management by funds analyzed from this family.'
            ),
            format.money(this.props.assets, true, 'USD', true),
            'in assets analyzed'
          )
        }
        <ReactTooltip id='flaggedfund-tooltip'/>
      </div>
    )
  }
}
